var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"login"}},[_c('el-button',{attrs:{"loading":_vm.loggingIn},on:{"click":function($event){return _vm.authenticate('github')}}},[_vm._v("Login with Github")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }